// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const PatientProfilePeopleOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"clip-rule":"evenodd","fill-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2","viewBox":"0 0 32 32","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M9.73 14.07A6.98 6.98 0 004 20.95v4.04a3 3 0 003 3h18a3 3 0 003-3v-4.04a6.98 6.98 0 00-5.73-6.87 7 7 0 10-12.54 0zm11.17 1.88a6.97 6.97 0 01-9.8 0l-.12.01A4.98 4.98 0 006 20.94v4.04a1 1 0 001 1h18a1 1 0 001-1v-4.04a4.98 4.98 0 00-5.1-4.99zm-4.9-10a5 5 0 110 10.01 5 5 0 010-10z"}},{"tag":"path","attrs":{"d":"M20 20h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2h-1v-1a1 1 0 00-2 0v1z"}}]},"name":"patient-profile-people","theme":"outlined"};

const PatientProfilePeopleOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={PatientProfilePeopleOutlinedSvg} />;
  PatientProfilePeopleOutlined.displayName = 'PatientProfilePeopleOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(PatientProfilePeopleOutlined);
